<template>

    <div class="page-container">
      <md-app v-if="loaded">
        <md-app-toolbar class="md-primary">
          <md-button class="md-icon-button" @click="menuVisible = true">
            <md-icon>menu</md-icon>
          </md-button>
          <div class="md-toolbar-section-end">
            <md-menu md-direction="bottom-start">
              <md-button md-menu-trigger>{{ langs[$store.state.lang] }}</md-button>
              <md-menu-content>
                <md-menu-item @click="changeLanguage(key)" v-for="(lang, key) in langs">{{ lang }}</md-menu-item>
              </md-menu-content>
            </md-menu>
          </div>
        </md-app-toolbar>

        <md-app-drawer :md-active.sync="menuVisible" md-swipeable>
          <md-toolbar class="md-transparent" md-elevation="0">
            <span class="md-title">Museu d'Història de Manacor</span>
          </md-toolbar>

          <md-divider></md-divider>

          <md-list v-if="places">
            <md-list-item :to="'/'">
              <span class="md-list-item-text">{{ translations[$store.state.lang].global.menu_home}}</span>
            </md-list-item>
            <md-divider></md-divider>
            <md-subheader>Jaciments</md-subheader>
            <md-list-item v-for="place in places" :key="place.uuid[0].value" :to="{name: 'term', params: {lang: $store.state.lang, tid: place.tid[0].value}}">
              <span class="md-list-item-text">{{ place.name[0].value }}</span>
            </md-list-item>
            <md-divider></md-divider>
            <md-list-item href="https://museudemanacor.com/" target="_blank">{{ translations[$store.state.lang].global.menu_web}}</md-list-item>
          </md-list>
        </md-app-drawer>

        <md-app-content>
          <router-view :key="$route.fullPath"></router-view>
        </md-app-content>
      </md-app>
      <vue-splash v-else></vue-splash>
    </div>

</template>

<script>

    import { API } from "@/variables";
    import { LANG } from "@/lang";
    import VueSplash from "@/components/Splash";

    export default {
        components: {VueSplash},
        metaInfo: {
            title: "Inici",
            titleTemplate: '%s | Museu d\'Història de Manacor'
        },
        data() {
            return {
                translations: LANG,
                loaded: false,
                menuVisible: false,
                places: null,
                langs: {
                    'ca' : 'CAT',
                    'es' : 'ESP',
                    'en' : 'ENG'
                }
            }
        },
        watch: {
            '$route.path': function () {
                this.menuVisible = false;
            }
        },
        created() {
            if (localStorage.getItem('token')) {
                this.$http.defaults.headers.common['X-CSRF-Token'] = localStorage.getItem('token');
            }

            if (!localStorage.getItem('token')) {
              this.getSessionToken();
            }

        },
        mounted() {
            this.getPlaces()
        },
        methods: {
            webLogin() {
                this.$store.dispatch('webLogin');
            },
            getSessionToken() {
                this.$store.dispatch('sessionToken');
            },
            getPlaces() {
                this.$http.get(API.protocol + API.ip + '/' + this.$store.state.lang + '/api/places', {
                    header: {
                        'Content-Type': 'application/json',
                    },
                    withCredentials: true
                })
                    .then((response) => {
                        this.places = response.data;
                        this.$store.commit('setPlaces', this.places);

                        setTimeout(() => {
                            this.loaded = true;
                        },2000)
                    })
            },
            changeLanguage(lang) {
               let current = this.$route.params.lang;
               this.$store.commit('changeLanguage', lang);
               let newRoute = this.$route.path.replace('/' + current + '/', '/' + lang + '/');
               this.$router.push(newRoute);
            },
        }
    }
</script>

<style lang="scss" scoped>
  .md-app {
    height: 100vh;
  }
  .md-drawer {
    background-color: #ffffff;
    z-index: 999;
  }
</style>
